export default "../css/739d3a8ea28649450b0bd750d19facb5.ttf";